export default __webpack_public_path__ + "static/media/steinamrhein.cb20978d.jpeg";